


















































import { Component, Vue } from "vue-property-decorator";
import { Toast, Empty } from "vant";
const PDFJS = require("pdfjs-dist");
PDFJS.GlobalWorkerOptions.workerSrc = "pdfjs-dist/build/pdf.worker.js";

@Component({
  components: {
    [Empty.name]: Empty
  }
})
export default class Index extends Vue {
  noticePublicText: any = "";
  detailData = null;
  isTypeOfPDF = false;
  isTypeOfImg = false;
  imgTypeSupport = ["jpg", "jpeg", "png", "gif"];
  pdfDoc: any = "";
  pages = 0;
  $route: any;
  IMG_NET_ERR = (this as any).IMG_NET_ERR;
  requestFail = false;

  mounted() {
    this.noticePublicText = this.$t("notice.noticePublicText");
    const id = this.$route.query.id || null;
    if (id) {
      this.getNoticeData(id);
    } else {
      Toast.fail(this.$t("public.contentText[2]"));
    }
  }

  /**
   * 获取公告详情
   * @param id {string | number} 公告id
   */
  getNoticeData(id) {
    (this as any).$apis
      .getNoticeDetail({ id })
      .then(res => {
        this.requestFail = false;
        this.detailData = res;
        if (res.content_type === 2) {
          const fileType = this.getFileType(res.notice_url);
          if (fileType.toLowerCase() === "pdf") {
            this.isTypeOfPDF = true;
            this.handlePreviewCommonPdf(res.notice_url);
          } else if (this.imgTypeSupport.includes(fileType.toLowerCase())) {
            this.isTypeOfImg = true;
          } else {
            this.isTypeOfPDF = false;
            this.isTypeOfImg = false;
          }
        }
      })
      .catch(() => {
        this.requestFail = true;
      });
  }

  /**
   * @description 获取文件后缀名
   * @param filePath {string} file地址
   * @example https://baidu.com/file/123.mp4
   * @return {Object} 文件后缀 mp4
   */
  getFileType(filePath) {
    const startIndex = filePath.lastIndexOf(".");
    if (startIndex !== -1) {
      return filePath.substring(startIndex + 1, filePath.length).toLowerCase();
    } else {
      return "";
    }
  }

  handlePreviewCommonPdf(url) {
    (this as any).$apis
      .previewCommonPdf({
        pdf_url: url
      })
      .then(res => {
        this.loadFile(res.data);
      })
      .catch(e => {
        
      });
  }

  loadFile(url) {
    PDFJS.getDocument(url).then(pdf => {
      this.pdfDoc = pdf;
      this.pages = this.pdfDoc.numPages;
      this.$nextTick(() => {
        this.renderPage(1);
      });
    });
  }

  renderPage(num) {
    this.pdfDoc.getPage(num).then(page => {
      const canvas: any = document.getElementById("the-canvas" + num);
      const ctx = canvas.getContext("2d");
      const dpr = window.devicePixelRatio || 1;
      const bsr =
        ctx.webkitBackingStorePixelRatio ||
        ctx.mozBackingStorePixelRatio ||
        ctx.msBackingStorePixelRatio ||
        ctx.oBackingStorePixelRatio ||
        ctx.backingStorePixelRatio ||
        1;
      const ratio = dpr / bsr;
      const viewport = page.getViewport(
        screen.availWidth / page.getViewport(1).width
      );
      canvas.width = viewport.width * ratio;
      canvas.height = viewport.height * ratio;
      canvas.style.width = viewport.width + "px";
      canvas.style.height = viewport.height + "px";
      ctx.setTransform(ratio, 0, 0, ratio, 0, 0);
      const renderContext = {
        canvasContext: ctx,
        viewport: viewport
      };
      page.render(renderContext);
      if (this.pages > num) {
        this.renderPage(num + 1);
      }
    });
  }
}
